export enum LanguageEnum {
  EN = "en",
  UA = "ua",
}
